/**
 * Haelt den entsperrten Master-Key (CryptoKey) ausschliesslich im
 * Arbeitsspeicher. Bewusst NICHT im Redux-Store (nicht serialisierbar) und
 * NICHT im localStorage: nach einem Reload muss der Tresor neu entsperrt werden.
 *
 * Der Master-Key ist Portal-weit: alle gesicherten Module (Wissen,
 * Investitionen, ...) ver- und entschluesseln mit demselben Schluessel.
 */
let masterKey = null;

export const setzeMasterKey = (key) => {
  masterKey = key;
};

export const holeMasterKey = () => masterKey;

export const loescheMasterKey = () => {
  masterKey = null;
};

export const istEntsperrt = () => masterKey !== null;
